import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import defaults from "../constants/defaults";
import axios from "axios";

export default class DemoForm extends Component {
  state = {
    processedUser: false,
    hasUserError: false,
    hasServerError: false
  };

  _processUser = async () => {
    try {
      const { hasUserError } = this.state;
      if (hasUserError) {
        return;
      }
      const urlString = window.location.href;
      const url = new URL(urlString);
      const AccessPointID =
        url.searchParams.get("accesspoint_id") || defaults.AccessPointID;
      const DeviceID = url.searchParams.get("mac") || defaults.DeviceID;
      const fields = {
        AccessTimes: 1,
        DeviceID,
        DeviceType: navigator.userAgent,
        Registration_AP_ID: AccessPointID
      };
      await axios.post("/users", {
        fields
      });
      this.setState({
        processedUser: true
      });
    } catch (err) {
      this.setState({
        hasServerError: true
      });
    }
  };

  _saveDemoInfo = async () => {
    try {
      const ageInput = document.getElementById("ageInput");
      const sexInput = document.getElementById("sexInput");
      const visitsInput = document.getElementById("visitsInput");
      const spendInput = document.getElementById("spendInput");
      const urlString = window.location.href;
      const url = new URL(urlString);
      const DeviceID = url.searchParams.get("mac") || defaults.DeviceID;
      const demoInfo = {
        DeviceID,
        Sex: sexInput.value,
        AgeRange: Number(ageInput.value),
        VisitRange: Number(visitsInput.value),
        SpendRange: Number(spendInput.value)
      };
      const hasBlank = Object.values(demoInfo).some(val => {
        return val === "" || val === 0;
      });
      await this.setState({
        hasUserError: hasBlank
      });
      if (hasBlank) {
        return;
      }
      await axios.post("/demographics", demoInfo);
    } catch (err) {
      console.log(err);
      await this.setState({
        hasServerError: true
      });
    }
  };

  render() {
    const { processedUser, hasServerError, hasUserError } = this.state;
    const urlString = window.location.href;
    const url = new URL(urlString);
    const DeviceID = url.searchParams.get("mac") || defaults.DeviceID;
    const AccessPointID =
      url.searchParams.get("accesspoint_id") || defaults.AccessPointID;
    const LocationID =
      url.searchParams.get("location_id") || defaults.LocationID;
    if (processedUser) {
      return (
        <Redirect
          to={`/?demo=success&mac=${DeviceID}&accesspoint_id=${AccessPointID}&location_id=${LocationID}`}
        />
      );
    } else {
      return (
        <div
          className="list-group"
          style={{
            flex: 1,
            padding: "10px",
            maxWidth: "700px"
          }}
        >
          <img
            style={{
              maxWidth: "700px",
              margin: "0 auto",
              width: "80%",
              marginBottom: "5px",
              marginTop: "20px"
            }}
            src="/jpeg/conectate-header-alt.png"
          />
          <p
            className="text-center mt-3"
            style={{
              fontSize: "12px"
            }}
          >
            Ayúdanos con esta encuesta para servirte mejor:
          </p>
          <form className="mt-3 mb-4">
            <div className="input-group mb-3">
              <div className="input-group-prepend">
                <div className="input-group-text">
                  <img
                    style={{
                      height: "15px",
                      width: "15px"
                    }}
                    src="/icons/svg/person.svg"
                    alt="person"
                  />
                </div>
              </div>
              <select id="sexInput" className="form-control">
                <option value="" selected disabled hidden>
                  Sexo
                </option>
                <option>Hombre</option>
                <option>Mujer</option>
              </select>
            </div>
            <div className="input-group mb-3">
              <div className="input-group-prepend">
                <div className="input-group-text">
                  <img
                    style={{
                      height: "15px",
                      width: "15px"
                    }}
                    src="/icons/svg/star.svg"
                    alt="star"
                  />
                </div>
              </div>
              <select id="ageInput" className="form-control">
                <option value="" selected disabled hidden>
                  Edad
                </option>
                <option value={1}>13 - 20</option>
                <option value={2}>20 - 40</option>
                <option value={3}>40 - 60</option>
                <option value={4}>60+</option>
              </select>
            </div>
            <div className="input-group mb-3">
              <div className="input-group-prepend">
                <div className="input-group-text">
                  <img
                    style={{
                      height: "15px",
                      width: "15px"
                    }}
                    src="/icons/svg/dollar.svg"
                    alt="dollar"
                  />
                </div>
              </div>
              <select id="spendInput" className="form-control">
                <option value="" selected disabled hidden>
                  ¿Cuánto planeas gastar?
                </option>
                <option value={1}>$20 - $200</option>
                <option value={2}>$200 - $400</option>
                <option value={3}>$400 - $600</option>
                <option value={4}>$600+</option>
              </select>
            </div>
            <div className="input-group mb-3">
              <div className="input-group-text">
                <img
                  style={{
                    height: "15px",
                    width: "15px"
                  }}
                  src="/icons/svg/timer.svg"
                  alt="timer"
                />
              </div>
              <select id="visitsInput" className="form-control">
                <option value="" selected disabled hidden>
                  ¿Cuantas veces vienes al mes?
                </option>
                <option value={1}>1 - 2</option>
                <option value={2}>2 - 4</option>
                <option value={3}>4 - 8</option>
                <option value={4}>8+</option>
              </select>
            </div>
          </form>
          <button
            onClick={async () => {
              await this._saveDemoInfo();
              await this._processUser();
            }}
            className="btn btn-danger btn-block"
          >
            Continuar
          </button>
          <p
            className="mt-1 text-center"
            style={{
              fontSize: "12px"
            }}
          >
            Al continuar, acepto los{" "}
            <a href="/tyc.html">Términos y Condiciones</a>
          </p>
          {hasUserError ? (
            <div class="alert alert-danger mt-3" role="alert">
              Por favor responde todas las preguntas.
            </div>
          ) : null}
          {hasServerError ? (
            <div class="alert alert-danger mt-3" role="alert">
              Tu información no pudo ser guardada.
            </div>
          ) : null}
        </div>
      );
    }
  }
}
